import React from 'react';

const SellMyHomeContent = () => {
    return (
      <div>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque eu
          risus nisi. Aenean enim nisl, mollis tristique magna eget, rutrum
          placerat nisi. Quisque orci lacus, molestie id laoreet a, consectetur
          a mi. Pellentesque aliquam, turpis eget bibendum ultrices, augue velit
          facilisis tellus, sed placerat lorem felis laoreet magna. Praesent
          molestie, lacus non luctus pellentesque, felis ipsum pharetra felis,
          non ultricies justo mi vel ex. Nulla non gravida orci, ac mattis
          neque. Duis molestie, est eu aliquam tempus, tellus lorem sodales
          purus, eleifend hendrerit dui leo et eros. Aliquam erat volutpat.
          Pellentesque bibendum dictum ligula, vel semper nunc sollicitudin
          vitae. Donec imperdiet vel ipsum at ultrices. Vestibulum ac interdum
          mi, quis porttitor ante. Fusce condimentum varius pharetra. Praesent
          tempor turpis ac ultrices vestibulum. Duis finibus venenatis
          venenatis. Donec ut ligula neque. Proin ut euismod ligula. Quisque
          eleifend, diam et molestie finibus, felis mi volutpat lorem, vel
          lobortis augue metus vitae leo. Donec facilisis vitae nulla a
          pulvinar. Proin vitae ligula laoreet, gravida enim et, gravida ipsum.
          Suspendisse vel nulla mauris. Duis blandit facilisis porttitor.
          Aliquam in tortor vitae neque imperdiet faucibus. Vivamus volutpat
          pharetra tempor. Aliquam ut dui vitae dui commodo laoreet in quis
          lacus. Curabitur in lacus dapibus, condimentum felis sed, porttitor
          ante.
        </p>
      </div>
    );
}

export default SellMyHomeContent;
